import { Column, Editing, Item, Lookup, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

const RenkTanimalari = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const [brands, setBrands] = useState([]);
    let skipValidationCheck = false;
    const ref = useRef();

    useEffect(() => {
        fetchColors();
        fetchBrands();
        //eslint-disable-next-line
    }, []);

    const fetchColors = async () => {
        try {
            const response = await api.post("/getAllColors");
            setDataSources(response.data.data || []);
        } catch (error) {
            console.error("Error fetching colors:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Renkler getirilirken hata oluştu') + ":" + errorMessage);
        }
    };

    const fetchBrands = async () => {
        try {
            const response = await api.post("/getAllBrands");
            setBrands(response.data.data || []);
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Markalar getirilirken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching brands:", error);
        }
    };

    const addColor = async (newData, e) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...newData, is_active: true, create_user_id: employeeId };

        try {
            const response = await api.post("/createColor", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                e.component.saveEditData();
                toast.success(t('Renk başarıyla eklendi'));
                fetchColors();
            } else {
                throw new Error("Failed to create color");
            }
        } catch (error) {
            console.error("Error adding color:", error);
            let errorMessage = error.response.data.error || "";
            toast.error(t('Renk eklenirken hata oluştu') + ":" + errorMessage);
        }
    };

    const updateColor = async (data, e) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };

        try {
            const response = await api.post("/updateColor", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                e.component.saveEditData();
                //eslint-disable-next-line
                toast.success(t('Renk başarıyla güncellendi'));
                fetchColors();
            } else {
                throw new Error("Failed to update color");
            }
        } catch (error) {
            console.error("Error updating color:", error);
            let errorMessage = error.response?.data?.error || "";
            //eslint-disable-next-line
            toast.error(t('Renk güncellenirken hata oluştu') + ":" + errorMessage);
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addColor(e.newData, e);
            } else {
                updateColor(e, e);
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("Renk Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="popup"
                        allowUpdating
                        allowAdding
                        useIcons
                        popup={{
                            title: t("Renk Tanımı"),
                            showTitle: true,
                            width: "auto",
                            height: "auto",
                            position: { my: "center", at: "center", of: window },
                            dragOutsideBoundary: true,
                        }}
                        texts={{
                            saveRowChanges: "Kaydet",
                            cancelRowChanges: "İptal",
                            confirmDeleteMessage: "Silmek istediğinize emin misiniz?",
                            deleteRow: "Sil",
                            editRow: "Düzenle",
                            addRow: "Yeni Ekle",
                        }}
                    />
                    <Column
                        dataField="brand_id"
                        caption={t("Marka")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    // visible={false}
                    >
                        <RequiredRule />
                        <Lookup
                            dataSource={brands}
                            valueExpr="id"
                            displayExpr="brand_name"
                        />
                    </Column>
                    <Column
                        dataField="color_code"
                        caption={t("Kodu")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    // allowEditing={false}
                    // cellRender={(data) => {
                    //     if (data.text === "") {
                    //         return <i>OTOMATİK</i>
                    //     } else return <>{data.data.color_code}</>
                    // }}
                    >
                        <RequiredRule />

                    </Column>

                    <Column
                        dataField="color_name"
                        caption={t("Renk Adı")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    >
                        <RequiredRule />

                    </Column>
                    <Column
                        dataField="is_active"
                        caption={t("Geçerli")}
                        alignment="center"
                        selectedFilterOperation="contains"

                    >
                        {/* <RequiredRule /> */}

                    </Column>
                    <Toolbar>
                        <Item name="groupPanel" location="before" />
                        <Item location="after">
                            <RxButton
                                color='light'
                                outline
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd",
                                }}
                                onClick={fetchColors}>
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                        </Item>
                        <Item name="addRowButton" location="after" />
                        <Item location="after">
                            <RxButton
                                color='success'
                                onClick={(e) => ButtonOnExporting(
                                    e,
                                    ref,
                                    "Renk Tanımları",
                                    "Sayfa-1"
                                )}
                                style={{ paddingInline: "10px", color: "white" }}
                            >
                                <i className='fa fa-file-excel-o'></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};

export default RenkTanimalari;